module.exports = __webpack_public_path__ + "img/element1.05562cf7.svg";